import React from "react";

import {Stack} from "react-bootstrap";

import { LomavisPlatformIcon } from "../../../atoms/icons/LomavisPlatformIcon/LomavisPlatformIcon";
import { PLATFORM_LIST_WITH_ALL } from "@/config/constants";

interface LomavisPlatformIconList1Props {
    /** List of platforms to display icons for */
    platforms: Array<(typeof PLATFORM_LIST_WITH_ALL)[number]>;
}

/**
* Atoms: LomavisPlatformIconList1
* Renders a horizontal list of platform icons with a gap-2 spacing
*/
export const LomavisPlatformIconList1: React.FC<LomavisPlatformIconList1Props> = ({ platforms }) => {
    return (
        <Stack direction="horizontal" gap={2}>
            {platforms.map((platform, index) => (
                <LomavisPlatformIcon key={`${platform}-${index}`} platform={platform} />
            ))}
        </Stack>
    );
};
